import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'

export default function CtaBand({
  title = 'Ready to Transform Your Restaurant?',
  description = 'Join restaurants using Tillio POS to streamline operations. The only software you’ll ever need.',
  buttonLabel = 'Get Started Free',
}) {
  const navigate = useNavigate()

  return (
    <section className="py-20 bg-slate-50 text-center">
      <div className="container mx-auto max-w-4xl px-6">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">{title}</h2>
        <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">{description}</p>
        <Button size="lg" onClick={() => navigate('/onboarding')}>
          {buttonLabel}
        </Button>
      </div>
    </section>
  )
}
